// extracted by mini-css-extract-plugin
export default {"lock":"Blog_lock__Km8uJ","_lock":"Blog__lock__8lQg7","root":"Blog_root__8egGF","wrapper":"Blog_wrapper__der0f","page":"Blog_page__27Dyy","error-message":"Blog_error-message__wr-T3"};